import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, MapPinIcon, XIcon } from "lucide-react";
import { recentBuyers } from "../data/content";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(1 + Math.floor(Math.random() * 9));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  const initials = buyer.name.replace(/^Dra?\.\s/, "").split(" ").map(p => p[0]).join("");
  return <AnimatePresence data-id="element-39" data-mp="1164k5vn9q9x2">
      {open && !dismissed && <motion.div role="status" aria-live="polite" className="fixed bottom-24 left-3 right-3 z-40 sm:right-auto sm:w-[340px]" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-40" data-mp="1fvixfetytbhq">
          <div className="relative flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_-10px_rgba(5,14,29,0.45)] ring-1 ring-cream-200" data-id="element-41" data-mp="x518zmg61226">
            <div className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy-900 font-serif text-sm font-bold text-gold-300" data-id="element-42" data-mp="s4wollc4zn6o">
              {initials}
              <CheckCircle2Icon className="absolute -bottom-0.5 -right-0.5 h-4 w-4 rounded-full bg-white text-emerald-600" aria-hidden="true" data-id="element-43" data-mp="23klfuowfb8da" />
            </div>
            <div className="min-w-0" data-id="element-44" data-mp="2fn4tomsis3zu">
              <p className="truncate text-sm font-bold text-ink" data-id="element-45" data-mp="2fm35dgmhtl06">{buyer.name}</p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-46" data-mp="2knsir2x6uarf">
                just purchased <span className="font-semibold text-navy-800" data-id="element-47" data-mp="2pmdjr4k9kygx">Rhinoplasty MasterMap™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-muted" data-id="element-48" data-mp="1ryv2148mkm0s">
                <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-49" data-mp="1wwwtodk49tnv" />
                {buyer.country} · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-cream-100 hover:text-ink" aria-label="Dismiss notification" data-id="element-50" data-mp="21uyep413s31z">
              <XIcon className="h-4 w-4" data-id="element-51" data-mp="1e4u7ynsmbn6r" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}